import { useState, useEffect } from 'react';
import { Outlet, Link, useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

const navItems = [
  { path: '/', label: 'Dashboard', icon: '📊' },
  { path: '/contacts', label: 'Contactos', icon: '👥' },
  { path: '/contacts/new', label: 'Nuevo Lead', icon: '➕' },
  { path: '/tasks', label: 'Tareas', icon: '✅' },
];

export default function Layout() {
  const { user, logout } = useAuth();
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  // Cerrar el menú móvil al cambiar de ruta
  useEffect(() => {
    setSidebarOpen(false);
  }, [location.pathname]);

  return (
    <div className="min-h-screen bg-gray-50 flex">
      {/* Fondo oscuro al abrir el menú (solo móvil) */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 bg-black/50 z-20 md:hidden"
          onClick={() => setSidebarOpen(false)}
          aria-hidden="true"
        />
      )}

      {/* Sidebar: drawer en móvil, fijo en desktop */}
      <aside
        className={`fixed inset-y-0 left-0 z-30 w-64 bg-amazon-dark text-white flex flex-col transform transition-transform duration-200 ease-out md:static md:z-auto md:translate-x-0 ${
          sidebarOpen ? 'translate-x-0' : '-translate-x-full'
        }`}
      >
        <div className="p-4 border-b border-gray-700 flex items-start justify-between">
          <div>
            <h1 className="text-xl font-bold text-amazon-orange">📦 Amazon CRM</h1>
            <p className="text-xs text-gray-400 mt-1">Gestión de Clientes</p>
          </div>
          <button
            onClick={() => setSidebarOpen(false)}
            className="md:hidden text-gray-400 hover:text-white text-xl leading-none p-1"
            aria-label="Cerrar menú"
          >
            ✕
          </button>
        </div>

        <nav className="flex-1 p-4 overflow-y-auto">
          <ul className="space-y-2">
            {navItems.map((item) => (
              <li key={item.path}>
                <Link
                  to={item.path}
                  className={`flex items-center gap-3 px-3 py-3 md:py-2 rounded-lg transition-colors ${
                    location.pathname === item.path
                      ? 'bg-amazon-orange text-white'
                      : 'text-gray-300 hover:bg-gray-700 hover:text-white'
                  }`}
                >
                  <span>{item.icon}</span>
                  <span>{item.label}</span>
                </Link>
              </li>
            ))}
          </ul>
        </nav>

        <div className="p-4 border-t border-gray-700">
          <div className="text-sm text-gray-400 mb-2 truncate">{user?.email}</div>
          <button
            onClick={logout}
            className="w-full text-left px-3 py-2 text-gray-300 hover:bg-gray-700 hover:text-white rounded-lg transition-colors"
          >
            🚪 Cerrar Sesión
          </button>
        </div>
      </aside>

      {/* Contenido principal */}
      <main className="flex-1 min-w-0 flex flex-col">
        {/* Topbar solo en móvil */}
        <header className="md:hidden sticky top-0 z-10 bg-amazon-dark text-white px-4 py-3 flex items-center gap-3 shadow">
          <button
            onClick={() => setSidebarOpen(true)}
            className="text-2xl leading-none p-1 -ml-1"
            aria-label="Abrir menú"
          >
            ☰
          </button>
          <span className="font-bold text-amazon-orange">📦 Amazon CRM</span>
        </header>

        <div className="p-4 md:p-6 flex-1">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
